"use client";

import { Box, Card, Grid, Typography } from "@mui/material";
import Image from "next/image";
import { Suspense } from "react";

import PageContainer from "@/app/(protected)/components/container/PageContainer";
import { APP_NAME } from "@/app/(protected)/config/constants";
import AuthLogo from "@/components/auth/auth-logo";
import { LoginForm } from "@/components/auth/login-form";

function LoginFormWrapper() {
  return (
    <LoginForm
      title={`Bem-vindo ao ${APP_NAME}`}
      subtext={
        <Typography
          variant="subtitle1"
          mb={3}
          sx={{ textAlign: "center", color: "#475569" }}
        >
          Informe seus dados para acessar o sistema
        </Typography>
      }
    />
  );
}

export default function LoginPage() {
  return (
    <PageContainer title="Login" description="Página de login">
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          minHeight: "100vh",
          borderRadius: 0,
          overflow: "hidden",
          background: "#ffffff",
          "&:before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "radial-gradient(circle at 20% 50%, rgba(16, 185, 129, 0.05), transparent 50%), radial-gradient(circle at 80% 80%, rgba(52, 211, 153, 0.05), transparent 50%)",
            animation: "gradient 15s ease infinite",
          },
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{
            minHeight: "100vh",
            height: "100%",
            position: "relative",
            zIndex: 1,
          }}
        >
          <Grid
            size={{ xs: 12, sm: 12, lg: 7, xl: 8 }}
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box position="relative" sx={{ flex: 1 }}>
              <Box px={3} pt={3}>
                <AuthLogo href="/auth/login" />
              </Box>
              <Box
                sx={{
                  display: {
                    xs: "none",
                    lg: "flex",
                  },
                  alignItems: "center",
                  justifyContent: "center",
                  height: "calc(100vh - 100px)",
                  px: 4,
                }}
              >
                <Image
                  src="/images/backgrounds/login-bg-old.svg"
                  alt="Ilustração de login"
                  width={500}
                  height={500}
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    maxHeight: "500px",
                    filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.15))",
                  }}
                  priority
                />
              </Box>
            </Box>
          </Grid>

          <Grid
            size={{ xs: 12, sm: 12, lg: 5, xl: 4 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            <Box
              sx={{
                p: 4,
                width: "100%",
                maxWidth: 500,
              }}
            >
              <Card
                elevation={24}
                sx={{
                  p: 4,
                  borderRadius: 4,
                  backgroundColor: "white",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 12px 32px rgba(0,0,0,0.1)",
                    borderColor: "#10b981",
                  },
                }}
              >
                <Suspense fallback={<div>Carregando...</div>}>
                  <LoginFormWrapper />
                </Suspense>
              </Card>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </PageContainer>
  );
}
